<template>
  <div id="container" v-loading.fullscreen="loading">
    <div class="full_layout">
    {{DomesticCustom}}
      <div class="shopping_cart">
        <div class="shopping_box">
          <!-- 选择地址 -->
          <div class="checkout_box">
            <h3>{{ $t('base.shipTo') }}</h3>
            <ul class="address_list">
              <template v-for="(item, index) in addressList">
                <li :key="index" v-if="(index < 10)" :class="{ 'on': (checkAddress.Id == item.Id) }">
                  <div class="choose_address" @click="addCheck(item, index)">
                    <div class="on_Default" v-if="item.IsDefault">{{ $t('base.default') }}</div>
                    <div><span>{{ item.UserName }}</span> ({{ item.Country }})</div>
                    <div>
                      <span v-if="item.StreetAddress">{{ item.StreetAddress + ',' }}</span>
                      <span v-if="item.StreetAddress2">{{ item.StreetAddress2 + ',' }}</span>
                      <span v-if="item.City">{{ item.City + ',' }}</span>
                      <span v-if="item.StateCode">{{ item.StateCode + ',' }}</span>
                      <span v-if="item.ZipCode">{{ item.ZipCode }}</span>
                    </div>
                    <div class="line_txt1 phone">{{ item.Phone }}</div>
                  </div>
                  <span class="change text_blue chage_address" @click="addChange(item, index)">{{ $t('base.edit') }}</span>
                </li>
              </template>
            </ul>
          </div>
          <!-- checkout pay -->
          <div class="checkout_box">
            <h3>{{ $t('base.payWith') }}</h3>
            <!-- 支付方式 -->
            <ul class="pay_list">
              <li :class="{ 'on': (checkPay == item.LowerName), 'disabled': (item.isPrice == false) }" @click="payCheck(item)"
                v-for="(item, index) in payChannelsList" :key="index">
                <el-tooltip :disabled="item.isPrice" popper-class="tooltipPay" effect="dark"
                  :content="$t('base.USDTMinAmount', { price: item.MinAmount })" placement="top">
                  <div class="pay_list_div">
                    <el-image class="like_img" :src="payChannels[item.LowerName]" fit="contain"></el-image>
                  </div>
                </el-tooltip>
              </li>
            </ul>
          </div>
          <!-- checkout detail -->
          <div class="checkout_box">
            <h3>{{ $t('base.reviewItemsShipping') }}</h3>
            <div class="review_items table_head">
              <div>{{ $t('base.commodityTitle') }}</div>
              <div>{{ $t('base.itemPrice') }}</div>
              <div>{{ $t('base.shipping') }}</div>
              <div>{{ $t('base.buyerPermium') }}</div>
              <div>{{ $t('base.stateTax') }}</div>
              <div>{{ $t('base.orderTotal') }}</div>
            </div>
          </div>
          <div>
            <div class="review_items review_list">
              <div class="shopping_list">
                <div class="like_box ">
                  <el-image class="like_img" :src="cardDetail.TitImg" fit="contain"></el-image>
                  <p class="flex_one"><span class="line_txt4">{{ cardDetail.Title }}</span></p>
                </div>
                <div class="list_price">{{ areaSymbol }} {{ cardDetail.USD_Price }}</div>
              </div>
              <div>{{ areaSymbol }} {{ shipping }}</div>
              <div>{{ areaSymbol }} {{ serviceFee }}</div>
              <div>{{ areaSymbol }} {{ tax }}</div>
              <div>{{ areaSymbol }} {{ totalPrice }}</div>
            </div>
          </div>
        </div>
        <div class="Checkout">
          <div class="check_list">
            <span>{{ $t('base.item') }} (1)</span>
            <span class="price">{{ areaSymbol }} {{ cardDetail.USD_Price }}</span>
          </div>
          <div class="check_list">
            <span>{{ $t('base.shippingTo') }} {{ BusinessType == 2 ? 'Card Hobby' : checkAddress.ZipCode }}</span>
            <span class="price price_r">{{ shipping > 0 ? areaSymbol + ' ' + shipping : shippingText }}</span>
          </div>
          <div class="check_list" v-if="serviceFee != null">
            <span>
              <span class="buyerPermium">{{ $t('base.buyerPermium') }}<i
                  v-if="ServiceFeeRate">{{ ServiceFeeRate }}</i></span>
              <del class="buyerPermium text_gray small_text" v-if="(ServiceFeeRate != DiscountRate)">{{
    $t('base.buyerPermium')
  }}<i v-if="DiscountRate">{{ DiscountRate }}</i></del>
            </span>
            <span class="price">{{ areaSymbol }} {{ serviceFee }}</span>
          </div>
          <!-- <template v-if="TaxServiceFee!=null&&TaxServiceFee>0">
            <div class="check_list" v-if="(BusinessType!=2||(BusinessType!=2&&list.MemberSource=='US'))">
              <span>{{ $t('base.stateTax') }}</span>
              <span class="price">{{areaSymbol}} {{TaxServiceFee}}</span>
            </div>
          </template> -->
          <div class="check_list check_list_all">
            <span>{{ $t('base.orderTotal') }}</span>
            <span class="price">{{ areaSymbol }} {{ totalPrice }}</span>
          </div>
          <div class="check_list">
            <i18n path="alert.agreementAPrivacy" tag="p" class="text_gray">
              <router-link class="text_blue" :to="{ path: '/terms/privacy?type=2' }"
                target="_blank">{{ $t('base.service') }}</router-link>
              <router-link class="text_blue" :to="{ path: '/terms/privacy?type=1' }"
                target="_blank">{{ $t('base.privacy') }}</router-link>
            </i18n>
          </div>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='payOrder()'>
            {{ $t('base.confirmPay') }}</el-button>
          <span class="text_gray finish">{{ $t('alert.checkoutOn') }} {{ checkPayUpper }}</span>
        </div>
      </div>
    </div>
    <!-- edit address -->
    <order-check v-if="dislogType.ordercheck" dialogClass="taxBox" :domVisible="dislogType.ordercheck"
      @closeDialog="closeDialog" @addOrder="addOrder" :title="$t('alert.sureBuyItem')" :orderCheckList="orderCheckList"
      :list="list" />
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。

import OrderCheck from "@/components/dialog/ordercheck"; // 一口价下单二次确认

import { getInfo, addressList, numAdd, numMulti, setInfo, isNumber, goPay, priceExchange, GetWorldUSD, GetWorldBUYUSD, isUserDomest, setPayList } from "@/api/public";
import qs from 'qs'
export default {
  name: 'index',
  components: {
    OrderCheck
  },
  data() {
    return {
      isChina:['HK','TW','MO','CN'],
      loading: false,
      DomesticCustom:'',
      CommodityID: '',
      userInfo: getInfo(),
      BusinessType: 0,
      cardDetail: {},
      checkPay: 'stripe',
      checkPayUpper: 'Stripe',
      payChannelsList: [],
      addressList: [],
      dislogType: this.$enumInfo.dislogType,
      orderCheckList: null,
      areaSymbol: this.$store.state.areaSymbol,
      payChannels: this.$enumInfo.payChannels,
      payEnum: this.$enumInfo.paylist,
      IsGuarantee: 6,
      shipping: 0,
      cnShipping: 0,
      shippingText: '',
      serviceFee: 0,
      Discount: 0,
      tax: 0,
      chooseAddress: 0,
      checkAddress: '',
      agencyProvice: '',
      ServiceList: '',
      ServiceFeeRate: '',
      DiscountRate: '',

    }
  },
  watch: {
    '$route': 'getPath',
  },
  computed: {
    totalPrice() {
      const that = this;
      let totalPrice = 0
      const unitPrice = that.cardDetail.USD_Price
      const shipping = that.shipping
      const serviceFee = that.serviceFee
      const tax = that.tax
      let price = numAdd(unitPrice, shipping) // 单价+邮费
      let price2 = numAdd(serviceFee, tax) // 服务费+税费
      totalPrice += numAdd(price, price2) //总额
      return totalPrice
    },
    addCheck() {
      const that = this;
      return function (obj) {
        that.checkAddress = obj
        that.GetPostPrice(obj)
        that.GetServiceFee()
      }
    }

  },
  mounted() { },
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.checkout'));
    this.CommodityID = this.$route.params.id
    this.userInfo = getInfo()
    GetWorldBUYUSD(this.userInfo.MemberSource);
    Promise.all([this.GetDetailCommodity()]).then(() => {
      this.isPayChannels()
      this.getAddressList()
    })

    // this.list = window.sessionStorage.getItem('check');
    // //console.log(this.list,'this.list')
    // this.list = JSON.parse(this.list);
    //GetWorldUSD()
    // this.cid = this.list.Details[0].ID ? this.list.Details[0].ID : ''
    // this.BusinessType = this.list.BusinessType ? this.list.BusinessType : ''
    // this.getMemberAreas('US')
  },
  methods: {

    // 一口价首次购买
    /**
     * 获取商品详情信息
     * 通过接口请求获取商品的详细信息,包括商品基本信息、邮费模板等
     * 处理商品价格转换(澳门地区)并更新商品列表数据
     * 
     * @function GetDetailCommodity
     * @returns {void}
     * 
     * @description
     * - 请求商品详情接口
     * - 设置商品邮费模板
     * - 构建商品详情对象(包含卖家信息、商品信息、价格等)
     * - 处理澳门地区的价格转换
     * - 更新商品列表数据
     * - 获取店铺列表
     */
    GetDetailCommodity() {
      let that = this;
      //console.log(2)
      let data = {
        memberid: that.userInfo.MappingUserId,
        token: that.userInfo.ChineseToken,
        operator_id: that.userInfo.MappingUserId,
        CommodityID: that.$route.params.id,
        buyerSource: that.userInfo.MemberSource
      }
      return this.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          //获取商品详情邮费模板
          that.DomesticCustom = result.DomesticCustom;
          that.CustomizeDomesticCustom = result.CustomizeDomesticCustom;
          console.log(that.DomesticCustom,'that.DomesticCustom')
          console.log(that.CustomizeDomesticCustom,'that.CustomizeDomesticCustom')
          that.cardDetail = res.data
          if (that.userInfo.MappingUserId != res.data.MemberSource) {
            that.BusinessType = 2
          }
          //that.GetStoresList(result)
          //that.getServiceList(result)
        }
      })
    },
    /**
     * 获取支付渠道列表并设置默认支付方式
     * 通过用户所在地区获取可用的支付渠道,设置默认支付方式和相关支付参数
     * @method isPayChannels
     * @returns {void}
     * 
     * - 调用接口获取支付渠道列表
     * - 处理支付渠道数据,设置USDT支付索引
     * - 设置默认支付方式和保证金状态
     * - 检查是否包含其他支付方式(蚂蚁金服)
     * - 失败时设置默认为Stripe支付
     */
    isPayChannels() {
      let that = this
      let data = { areaCode: that.userInfo.MemberSource }
      
      that.checkPay = 'stripe'
      that.checkPayUpper = 'Stripe'
      that.IsGuarantee = that.payEnum[that.checkPay]
      that.$get(that.$interface.GetPayChannels, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          data = setPayList(data, that.userInfo)
          data.map((item, i) => {
            if (item.ChannelName == 'USDT') {
              that.isUSDT = i
            }
          })
          that.checkPay = data[0].LowerName
          that.checkPayUpper = data[0].ChannelName
          that.IsGuarantee = that.payEnum[that.checkPay]
          that.payChannelsList = data
          
          that.getServiceList()
          // //其他支付方式=》蚂蚁金服
          // let isOther = data.filter(item => {
          //   return item.LowerName == 'other'
          // })
          // if (isOther.length > 0) {
          //   that.isOtherPay = true
          // }
          //end
          // that.getAntPay()
        }
      })
    },
    // 复制
    CopyLink(val) {
      let that = this
      this.$copyText(val).then(function (e) {
        that.isCopy = true
        that.$message({
          message: 'Successfully',
          type: 'success'
        });
      }, function (e) {
        that.isCopy = false
        that.$message.error('Fail');
      })
    },
    /**
     * 更新运输地址信息
     * @description 根据用户选择的地址类型(普通地址/代理地址)更新订单的运输地址
     * @function UpdateTransport
     * @private
     * @returns {Promise} 返回更新结果的Promise对象
     * - 成功时重新获取订单信息
     * - 失败时显示错误消息并转接服务
     */
    UpdateTransport() {
      let that = this
      //that.disabled = true;
      that.loading = true;
      var orderid = that.isAreas ? that.orderAddId : that.AgencyId
      console.log(that.orderAddId, "that.orderAddId", that.AgencyId, "that.AgencyId")
      let data = { memberid: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, addressId: orderid, orderId: that.list.ID, IsGuarantee: that.IsGuarantee, IsCustomAdress: that.isAreas }
      console.log(data, 'data')
      that.$post(that.$interface.UpdateTransportAddress, data).then(res => {
        if (res.result != 0) {
          //that.GetOrder()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
          that.transferService()
        }
        //that.disabled = false;
        that.loading = false;
      })
    },
    /**
     * 更新订单信息
     * @description 根据用户信息和地址ID更新订单状态，包含普通订单和代理商订单的处理
     * @function UpdateOrdinary
     * @private
     * @returns {Promise<void>} 更新订单后的处理结果
     * 
     * 功能：
     * - 根据业务类型选择不同的地址ID
     * - 发送更新订单请求
     * - 更新成功后重新获取订单信息
     * - 更新失败时显示错误提示
     */
    UpdateOrdinary() {
      let that = this
      //that.disabled = true;
      that.loading = true;
      var addressId = that.orderAddId;
      if (that.BusinessType == 2) {
        addressId = that.AgencyId
        //console.log(that.AgencyId,'that.AgencyId')
      }
      let data = { memberid: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, addressId: addressId, orderId: that.list.ID, IsGuarantee: that.IsGuarantee }
      let url = this.$interface.UpdateOrder
      this.$post(url, qs.stringify(data)).then(res => {
        if (res.result != 0) {
          //that.GetOrder()
          //that.checkAdd = obj
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
        //that.disabled = false;
        that.loading = false;
      })
    },

    
    /**
     * 判断是否需要转运地址
     * @returns {boolean} 是否需要转运地址
     * - 订单已生成时:
     *   - 非转运业务且有订单地址时返回 true
     *   - 转运业务且在服务区域内返回 true
     *   - 转运业务且不在服务区域内返回 false
     * - 订单未生成时:
     *   - 转运业务且在服务区域内返回 true
     *   - 其他情况返回 false
     */
    isTransferAddress() {
      let that = this
      if (that.BusinessType == 2 && that.isAreas) {
        return true
      } else if (that.BusinessType == 2 && !that.isAreas) {
        return false
      } else {
        return false
      }
    },
    /**
     * 获取会员地址信息
     * @param {string} MemberSource - 会员来源地区代码(如:'CN','MO','HK'等)
     * @description 根据会员ID和地区获取对应的收货地址信息,并设置相关状态
     * - 设置地址使用状态(transferText)
     * - 更新地址信息(orderAdd)
     * - 处理特殊地区会员(如澳门/香港/台湾会员)的地址逻辑
     * @private
     */
    getMemberAreas(MemberSource) {
      let that = this
      // console.log(MemberSource, 'MemberSourceeee')
      that.transferText = that.$t('base.doNotUsing')
      let data = { 'memberid': that.userInfo.Id, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'Country': MemberSource, PageIndex: 1, PageSize: 10 }
      //console.log(data,'data')
      this.$get(that.$interface.GetMemberByMemberId, data).then(res => {
        if (res.result != 0) {
          var result = res.data[0]
          //console.log(result, 'result')
          if (res.count > 0) {
            that.transferCount = res.count
            that.transferText = that.$t('base.using')
            that.isAreas = true;
            that.orderAddId = result._id
            that.orderAdd = {
              Id: result._id,
              UserName: result.UserName,
              Country: result.Country,
              StreetAddress: result.StreetAddress,
              StreetAddress2: result.StreetAddress2,
              City: result.City,
              State: result.State,
              ZipCode: result.ZipCode,
              Phone: result.Phone,
              StateCode: result.StateCode,
              IsDefault: true
            }
            //console.log(res.data,'res.data')
            // console.log("####",result.Country);
            that.getAreasList(undefined, result.Country);
          } else {
            that.isAreas = false;

            //@todo
            // if(that.userInfo.MemberSource=='MO'||that.userInfo.MemberSource=="HK"||that.userInfo.MemberSource=="GB"){
            //   that.isAreas = true;
            // that.transferText = that.$t('base.using')
            // }
          }
        } else {
          that.isAreas = false;
        }
        if (that.again != undefined) {
          //that.transferInitialize()
        } else {
          //&&MemberSource=="CN"
          that.isAgencyMO = (that.userInfo.MemberSource == 'MO' || that.userInfo.MemberSource == "HK" || that.userInfo.MemberSource == "TW") && (MemberSource == "CN" || MemberSource == "MO" || MemberSource == "HK" || MemberSource == "TW")
          if (that.isAgencyMO && that.transferCount <= 0) {

            that.isAreas = true;
            that.transferText = that.$t('base.using');
            that.isMOHK = true;
          } else {
            that.isMOHK = false
            that.transferInitialize()
          }
        }


        // console.log(res, 'getMemberAreas')
      })
    },
    // 切换转运仓地址
    /**
     * 处理转运地址服务的切换逻辑
     * 根据当前状态切换转运地址的使用状态
     * - 如果当前正在使用转运地址,则关闭转运地址
     * - 如果当前未使用转运地址:
     *   - 无转运地址时弹出确认框提示添加
     *   - 有转运地址时启用转运地址
     * @fires transferInitialize 初始化转运地址相关数据
     */
    transferService() {
      let that = this
      that.transferText = that.$t('base.doNotUsing')
      if (that.isAreas) {
        that.isMOHK = false;
        that.isAreas = false;
        that.transferText = that.$t('base.doNotUsing')
        // if (that.transferCount <= 0) {
        //   that.disabled=false
        //   console.log(1)
        // }
        //console.log(that.isAreas, 'that.isAreas')
        // if (that.transferCount > 0) {
        //   that.isAreas = false;
        //   that.transferText = that.$t('base.doNotUsing')
        // }
      } else {
        if (that.transferCount <= 0) {
          //沒地址，要
          that.confirmHint()
        } else {
          that.isAreas = true;
          that.transferText = that.$t('base.using')
        }

      }
      that.transferInitialize()

    },
    confirmHint() {
      let that = this
      let html = '<div class="confirmData pleaseNote"><p>' + that.$t('alert.pleaseNote') + '<span class="text_red">' + that.$t('alert.notResponsible') + '</span></p><p>' + that.$t('alert.onlyRemember') + '</p></div>'
      that.$confirm(html, that.$t('base.hint'), {
        distinguishCancelAndClose: true,
        confirmButtonText: that.$t('base.cancel'),
        cancelButtonText: that.$t('base.usingMyTransferAddress'),
        customClass: "confirmBox",
        lockScroll: false,
        dangerouslyUseHTMLString: true
      }).then(() => { }).catch((action) => {
        if (action == 'cancel') {
          that.addChange('', 'new')
        }
      });
    },
    // 跨境订单切换地址模式
    /**
     * 初始化运输相关信息
     * 根据订单状态进行不同处理:
     * - 如果是再次购买(again不为undefined),根据transferCount更新运输信息或获取区域列表
     * - 如果是首次购买,根据isAreas判断是否需要获取税费和邮费,或获取代理信息
     * @private
     */
    transferInitialize() {
      let that = this
      //console.log(123123123)
      if (that.again != undefined) {
        //console.log('asdasdasda',that.transferCount)
        //@todo 更新订单
        if (that.transferCount > 0) {
          //alert(1)
          that.UpdateTransport()
          // if (that.isAreas) {
          //   that.UpdateTransport()
          // } else {
          //   that.UpdateOrdinary()
          // }
        } else {
          //alert(2)
          //  console.log(that.passForm, 'that.checkAdd')
          that.passForm.Country = that.list.SellMemberSource
          that.getAreasList(undefined, that.list.SellMemberSource);
        }

      } else {
        if (that.isAreas) {
          // console.log(that.orderAdd, that.orderAdd.Country, 'that.orderAdd, that.orderAdd.Country')
          that.agencyProvice = null
          that.GetTaxPrice(1)
          that.GetPostPrice(that.orderAdd, that.orderAdd.Country)
        } else {

          // console.log(that.orderAdd, 'that.orderAdd')
          that.GetAgency({ MemberSource: that.list.MemberSource })
        }
      }
    },
    // Something Important 弹框
    /**
     * 显示重要转账提示对话框
     * 使用 Element UI 的 alert 组件展示转账相关的重要提示信息
     * 包含免责声明和注意事项
     * @returns {void}
     */
    transferImportant() {
      let that = this
      let html = '<div class="confirmData pleaseNote"><p>' + that.$t('alert.pleaseNote') + '<span class="text_red">' + that.$t('alert.notResponsible') + '</span></p><p>' + that.$t('alert.onlyRemember') + '</p></div>'
      this.$alert(html, that.$t('base.hint'), {
        distinguishCancelAndClose: true,
        customClass: "confirmBox",
        lockScroll: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: that.$t('base.know'),
        callback: action => { }
      });
    },
    getServiceList(obj) {
      const that = this;
      const SellMemberSource = that.cardDetail.MemberSource || that.cardDetail.SellMemberSource
      const BuyMemberSource = that.userInfo.MemberSource

      const data = { buyerSource: BuyMemberSource, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }

      const serviceListRate = (SellMemberSource) => {
        const serviceRate = that.ServiceList.filter(res => (res.SellerSource === SellMemberSource && res.PayType.toLowerCase() === that.checkPay))[0]
        try {
          that.ServiceFeeRate = serviceRate.Fee != 0 ? '(' + (numMulti(serviceRate.Fee, 100)) + '%)' : '(0%)'
          that.DiscountRate = serviceRate.Discount != 0 ? '(' + (numMulti(serviceRate.Discount, 100)) + '%)' : '(0%)'
        } catch (error) {
          console.log(error)
          that.ServiceFeeRate = that.DiscountRate = 0
        }
      }
      if (!that.ServiceList) {
        that.$get(that.$interface.GetServiceList, data).then(res => {
          if (res.result != 0) {
            var result = res.data
            that.ServiceList = result
            serviceListRate(SellMemberSource)
          }
        })
      } else {
        serviceListRate(SellMemberSource)
      }
    },
    // 获取服务费 type 1:卡片ID，2:订单ID,obj：地址
    /**
     * 获取服务费用信息
     * @param {number} type - 获取服务费类型 1:通过商品ID获取 2:通过订单ID获取
     * @param {Object} obj - 参数对象
     * @description 根据不同类型请求获取服务费用,包含服务费和折扣信息
     * 当type=1时通过商品ID获取,type=2时通过订单ID获取
     * 获取成功后会更新组件的ServiceFee和Discount数据
     */
    GetServiceFee(type, obj) {
      console.log(this.CommodityID, this.cnShipping, 'type, obj')
      let that = this;
      let data = { postageMoney: that.cnShipping, isGuareent: that.IsGuarantee, token: that.userInfo.ChineseToken, operator_id: that.userInfo.MappingUserId, memberId: that.userInfo.MappingUserId, commodityId: that.CommodityID }

      that.$get(that.$interface.GetServiceFeeByCommodityID, data).then(res => {
        if (res.result != 0) {
          that.serviceFee = priceExchange(res.data.ServiceFee, 'USD')
          that.Discount = priceExchange(res.data.Discount, 'USD')

        }
      })
    },
    // 获取税 type 1:卡片ID，2:订单ID,
    /**
     * 获取税费价格信息
     * @param {string} type - 请求类型参数
     * @description 根据不同场景(重复购买/首次购买)获取税费价格信息
     * - 重复购买时使用订单ID和州名获取
     * - 首次购买时使用商品ID和州名获取
     * - 获取成功后更新组件的TaxServiceFee(税费)和TaxDiscount(折扣)
     */
    GetTaxPrice(type) {
      let that = this
      // console.log(type, 1, that.again)
        //console.log(that.BusinessType, that.isAreas, that.orderAdd, 'that.checkAdd12312312')
        var StateName = that.checkAdd.State
        if (that.BusinessType == 2) {
          StateName = that.userInfo.State
          if (that.isAreas) {
            StateName = that.orderAdd.State
          }
        }
      let data = { operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, commodityId: that.CommodityID, StateName: StateName }
      //console.log(data, 'that.orderAdd111')
      that.$get(that.$interface.GetTaxPrice, data).then(res => {
        if (res.result != 0) {
          that.TaxServiceFee = priceExchange(res.data.TaxPrice, 'USD')
          that.TaxDiscount = priceExchange(res.data.Discount, 'USD')
        }
      })

    },
    // 获取商品列表判断是否是跨境订单
    /**
     * 处理商店列表获取和地址相关逻辑
     * @param {Object} obj - 包含商店信息的对象
     * @param {number} obj.MemberSource - 会员来源
     * @param {number} obj.OrderType - 订单类型
     * @description 根据会员来源和订单类型判断是同境/官方商城还是跨境订单,
     * 同境/官方商城: 获取地址列表和区域列表
     * 跨境订单: 设置跨境业务类型,获取卖家所在区域的州列表和会员区域信息
     */
    GetStoresList(obj) {
      let that = this
      //console.log(obj)
      // 同境或者官方商城
      if ((obj.MemberSource == that.userInfo.MemberSource) || obj.OrderType == 1) {
        this.getAddressList();
        this.getAreasList();
        that.BusinessType = 0;
      } else {
        // 跨境
        that.BusinessType = 2;
        //跨境税
        //this.GetTaxPrice()

        //console.log(that.checkAdd, 'res1231231231')
        that.checkAdd = { 'Id': 0 };
        that.passForm.Country = obj.MemberSource
        //console.log(obj, '321321')
        // 跨境自定义地址，卖家所在区域的全部州
        that.getAreasList(undefined, obj.MemberSource);

        that.isAgencyMO = (that.userInfo.MemberSource == 'MO' || that.userInfo.MemberSource == "HK" || that.userInfo.MemberSource == "TW") && (obj.MemberSource == "CN" || obj.MemberSource == "MO" || obj.MemberSource == "HK" || obj.MemberSource == "TW")
        if (that.isAgencyMO) {
          console.log(1111111)
          that.getMemberAreas(obj.MemberSource)
        } else {

          //获取办事处地址信息
          that.GetAgency(obj)
        }

      }

      //console.log('res.Data',that.list.USD_TotalPrice,that.postPrice, that.totalPrice(that.list.USD_TotalPrice,that.postPrice))

    },
    //获取办事处地址信息
    /**
     * 获取代理商信息
     * @param {Object} obj - 包含会员来源信息的对象
     * @description 根据用户信息获取代理商详细信息，包括地址、省份等，并可选择性地获取邮费
     * @returns {Promise} 返回代理商信息的请求Promise
     */
    GetAgency(obj) {
      let that = this
      //console.log(obj, '123123')
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: (obj.MemberSource || obj.SellMemberSource) }
      this.$get(this.$interface.GetAgency, data).then(res => {
        if (res.result != 0) {
          that.AgencyId = res.data.Id
          that.agencyProvice = res.data
          //console.log(res.data.AgencyAddress,res.data,'GetAgency')
          that.cardHobbyAddress = res.data.AgencyAddress + ", " + res.data.Provice + ", " + res.data.Nation + "."
          if (that.again == undefined || !that.again) {
            that.GetPostPrice(res.data, res.data.AreaId)
          }
        }
      })
    },
    //新增订单and 更新订单
    /**
     * 添加订单并处理支付流程
     * 处理订单创建、验证和支付流程的方法
     * @description
     * - 验证地址信息和订单金额
     * - 创建新订单或处理重复支付
     * - 支持自定义地址和不同支付方式
     * - 包含订单金额验证(>0.5美元)
     * - 处理订单状态跳转
     * @private
     */
    addOrder() {
      let that = this
      let data = { addressId: that.checkAdd.Id, commodityid: that.list.Details[0].ID, QuantitySold: 1, memberid: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, IsGuarantee: that.IsGuarantee }
      // that.disabled = true;
      that.loading = true
      console.log(data, 'this.address.length,this.BusinessType')
      let url = this.$interface.AddOrder
      if (this.again != undefined) {

        // that.disabled = true;
        that.payOrder()
        //window.location.href = this.$interface.pay + '?id=' + that.again
      } else {
        //价格小于0.5美元不能支付
        //totalPrice(this.list.USD_TotalPrice,postPrice)
        var totalPrice = this.totalPrice(this.list.USD_TotalPrice, this.postPrice)
        //console.log(totalPrice,'价格小于0.5美元不能支付')
        if (isNumber(totalPrice) > 0.5) {
          // that.disabled = true;
          if (this.address.length <= 0 && this.BusinessType != 2) {
            let msg = this.$t('alert.noAddress')
            this.$message({
              type: 'error',
              // message: res.msg
              message: msg
            });
          } else {
            if (that.isAreas) {
              data.IsCustomAdress = that.isAreas
              //data.IsCustomAdress = that.orderAdd
              data.IsCustomAdressId = that.orderAdd.Id
            }
            //console.log(data,'data')
            const OrderCreate = function () {
              // that.disabled = true;
              that.$post(url, qs.stringify(data)).then(res => {
                //console.log(res, 'res')
                if (res.result != 0) {
                  let orderid = res.data.ID
                  if (that.again != undefined) {
                    orderid = that.again
                  }
                  if (res.data.OrderStatus == 2) {
                    that.$router.push({
                      path: '/mycardhobby/purchase?type=2'
                    })
                  } else if (res.data.OrderStatus == 1) {
                    that.payOrder(orderid)
                  }




                  // if (this.checkPay == 'stripe') {
                  //   goPay('pay', ('?id=' + orderid))
                  // } else {
                  //   goPay('paypal', ('?paysource=1&id=' + orderid))
                  // }
                  //window.location.href = this.$interface.pay + '?id=' + orderid
                  //
                } else {
                  //that.disabled = false;
                  that.$message({
                    type: 'error',
                    // message: res.msg
                    message: res.msg
                  });
                }

              })
            }
            if (that.dislogType.ordercheck) {
              that.dislogType.ordercheck = !that.dislogType.ordercheck
              OrderCreate()
            } else {
              that.orderCheckList = { areaSymbol: that.areaSymbol, ServiceFee: that.ServiceFee, TaxServiceFee: that.TaxServiceFee, postPrice: that.postPrice, postageMoney: that.postageMoney, totalPrice: that.totalPrice(that.list.USD_TotalPrice, that.postPrice), shipping: (that.BusinessType == 2 && !that.isAreas ? 'Card Hobby' : that.checkAdd.ZipCode || that.orderAdd.ZipCode) }
              that.dislogType.ordercheck = !that.dislogType.ordercheck
              //that.disabled = false;
            }
            // this.$confirm('<div style="text-align: center;">'+that.$t('alert.sureBuyItem')+'</div>', that.$t('base.hint'), {
            //   lockScroll: false,
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonText: this.$t('base.pay'),
            //   cancelButtonText: this.$t('base.cancel')
            // }).then(() => {
            // }).catch(() => {

            // });
          }
          that.loading = false
        } else {
          this.$alert(this.$t('alert.payTip'), '', {
            confirmButtonText: 'Confirm',
            lockScroll: false,
            callback: action => {
              //that.disabled = false;
              that.loading = false
            }
          });
        }
      }
    },
    // 支付
    /**
     * 处理订单支付逻辑
     * @param {string|number} id - 订单ID,如果为空则使用 this.again
     * @description 根据选择的支付方式(stripe/paypal/mpay/other/usdt)跳转到对应的支付页面
     * @example
     * // 使用 stripe 支付
     * payOrder('123456')
     */
    payOrder(id) {
      var orderid = id && id != null ? id : this.again
      //goPay('pay', ('?id=' + this.again))
      // mplay song
      // if (this.userInfo.MemberSource == 'MO') {
      //   goPay('Mpay', ('?id=' + orderid))
      // } else {
      //   //...
      // }
      //this.disabled=true
      this.loading = true
      if (this.checkPay == 'stripe') {
        goPay('pay', ('?id=' + orderid))
      } else if (this.checkPay == 'paypal') {
        //goPay('paypal', ('?paysource=1&id=' + orderid))
        goPay('paypal', ('&Id=' + orderid))
      } else if (this.checkPay == 'mpay') {
        goPay('Mpay', ('?id=' + orderid))
      } else if (this.checkPay == 'other') {
        goPay('antCpay', ('?OrderId=' + orderid + '&PaymentMethodType=' + this.paymentMethodType + '&DeviceType=1'))
      } else if (this.checkPay == 'usdt') {
        goPay('usdt', ('?Id=' + orderid))
      }

    },
    //获取邮费 
    /**
     * 计算并设置邮费价格
     * @param {Object} obj - 包含邮费计算所需信息的对象
     * @param {string} source - 来源标识
     * @description 根据用户是否为国内用户计算邮费，并通过 setPostPrice 方法设置相关价格状态
     */
    GetPostPrice(obj, source) {
      let that = this
      let domesticCustom = that.DomesticCustom
      if (that.isAreas) {
        if (that.CustomizeDomesticCustom) {
          domesticCustom = that.CustomizeDomesticCustom
        }
      }
      var postPrice = isUserDomest(obj, domesticCustom, source, this.agencyProvice)
      if (postPrice) {
        this.setPostPrice(postPrice.USD_Price, postPrice.Status, postPrice.Price)
      }

    },
    // 邮费价格赋值 type 1:包邮，2:到付，3:自定义价格
    /**
     * 设置运费价格和相关配置
     * @param {number} price - 运费价格
     * @param {number} type - 运费类型 (1:免运费, 2:货到付款)
     * @param {number} CNprice - 人民币价格
     * @description 根据业务类型、用户来源地和运费类型计算最终运费。
     * 当业务类型为2或用户来源为澳门时，将人民币价格转换为美元。
     * 免运费和货到付款情况下运费为0。
     * 业务类型为2时会触发服务费计算。
     */
    setPostPrice(price, type, CNprice) {
      this.shipping = price;
      if (this.BusinessType == 2 && (!this.again || this.again == undefined)) {
        this.shipping = priceExchange(CNprice, 'USD');
      }
      // 用户是澳门人时，用澳门元汇率换算
      if ((!this.again || this.again == undefined) && this.userInfo.MemberSource == 'MO') {
        this.shipping = priceExchange(CNprice, 'USD');
      }
      this.cnShipping = CNprice;
      if (type == 1) {
        this.shipping = 0
        this.shippingText = this.$t('base.freeShipping')
      }
      if (type == 2) {
        this.shipping = 0
        this.shippingText = this.$t('base.payOnDelivery')
      }
      console.log(this.shipping,'shipping')
      //that.GetServiceFee()
      // if (this.BusinessType == 2) {
      //   this.GetServiceFee(1)
      // }
    },
    //取消编辑
    doneAddress() {
      this.address.map((val, i) => {
        if (val.IsDefault) {
          //console.log(val, 'val')
          this.GetPostPrice(val)
          this.checkAdd = JSON.parse(JSON.stringify(val))
          this.isAdd = i;
        }
      })
    },
    // //去重收货地址
    // setOrderAddressList(obj) {
    //   let that = this
    //   let add = that.address
    //   add.map((res, i) => {
    //     let oldadd = res.City + res.Country + res.Phone + res.state + res.StateCode + res.StreetAddress + res.StreetAddress2 + res.UserName + res.ZipCode
    //     let newadd = obj.City + obj.Country + obj.Phone + obj.state + obj.StateCode + obj.StreetAddress + obj.StreetAddress2 + obj.UserName + obj.ZipCode
    //     if (oldadd == newadd) {
    //       if (res.IsDefault) {
    //         that.orderAdd.IsDefault = true
    //       }

    //       that.orderAddId = res.Id
    //       this.address.splice(i, 1)
    //     }
    //   })
    //   if (that.again != undefined) {
    //     if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {
    //       var ChannelName = that.payChannelsList[0].LowerName
    //       if (that.checkPay != ChannelName) {
    //         that.payCheck(that.payChannelsList[0])
    //       }
    //     }
    //   }
    //   //console.log(that.address, obj, 'that.address')
    // },
    //获取地址列表  type新添加地址
    getAddressList(type) {
      let that = this
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result != 0) {
          that.addressList = res.Data
          that.addCheck(res.Data[0])
          //that.checkAddress=
          // if (type) {
          //   var endLength = this.address.length - 1
          //   this.GetPostPrice(this.address[endLength])
          //   this.checkAdd = this.address[endLength]
          //   this.isAdd = endLength;
          //   if (that.again != undefined) {
          //     that.setOrderAddressList(that.orderAdd);
          //   }

          // } else {
          //   if (that.again != undefined) {
          //     //订单列表或详情进入 去重收货地址
          //     if (that.orderAdd) {
          //       that.setOrderAddressList(that.orderAdd);
          //     }
          //   } else {
          //     if (this.isAdd > 0) {
          //       this.GetPostPrice(this.address[this.isAdd])
          //       this.checkAdd = this.address[this.isAdd]
          //     } else {
          //       if (res.Count.length > 1) {
          //         this.address.map((val, i) => {
          //           if (val.IsDefault) {
          //             this.GetPostPrice(val)
          //             this.checkAdd = JSON.parse(JSON.stringify(val))
          //             this.isAdd = i;
          //           }
          //         })
          //       } else {
          //         this.GetPostPrice(this.address[0])
          //         this.checkAdd = JSON.parse(JSON.stringify(this.address[0]))
          //         this.isAdd = 0;
          //       }
          //     }

          //     that.GetTaxPrice(that.checkAdd);
          //     that.GetServiceFee(1, that.checkAdd)
          //   }
          // }
          // this.disabled = false;
          this.loading = false
        }
      })
    },
    //获取地区列表
    getAreasList(val, memberSource) {
      //console.log(val, memberSource)
      let that = this;
      let data = { code: that.userInfo.MemberSource }
      let url = that.$interface.GetAreas
      if (memberSource && val == undefined) {
        data = { nationCode: memberSource }
        url = that.$interface.GetAreasAll
      }
      //console.log(val, memberSource, 'getAreasList')
      this.$get(url, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
          //console.log(res, 'getAreas')
          if (val != undefined) {
            //console.log(val, 'val1')
            let data = val
            res.Data.map(r => {
              if (data.State == r.EName) {
                data.StateCode = r.Code
              }
            })
            //console.log(data, 'val1')
            that.orderAdd = data;
            that.getAddressList()
          }
        }
      })
    },
    //设置地址选中
    // addCheck(obj, val) {
    //   //console.log(111, obj, val)
    //   let that = this
    //   that.checkAddress=obj
    //     // if (val != this.isAdd) {
    //     //   this.checkAdd = JSON.parse(JSON.stringify(obj))
    //     //   this.GetPostPrice(obj)
    //     //   //跨境税
    //     //   that.GetTaxPrice(that.checkAdd);
    //     //   //20260721 一口价购买切换地址也需要算服务费
    //     //   this.GetServiceFee(1, this.checkAdd)

    //     // }
    //     // this.isAdd = val;
    // },
    //select 州
    getState(val) {
      let that = this
      that.getAreas.map(res => {
        if (res.Code == val) {
          that.checkAdd.State = res.EName
        }
      })
    },
    // 修改支付方式
    payCheck(val) {
      let that = this
        this.checkPay = val.LowerName;
        this.checkPayUpper = val.ChannelName;
        this.IsGuarantee = this.payEnum[val.LowerName]
        that.paymentMethodType = ''

        this.GetServiceFee()

        that.getServiceList()
    },
    // 修改蚂蚁支付方式
    // antPayCheck(item){
    //   let that=this
    //   that.paymentMethodType=item.PaymentMethodType
    //   that.checkPayUpper=item.PaymentMethodCategory
    //   that.checkPay = 'other';
    //   that.IsGuarantee = that.payEnum['other']
    //   if (this.again != undefined) {
    //     that.GetServiceFee(2)
    //   } else {
    //     this.GetServiceFee(1, this.checkAdd)
    //   }
    // },
    // 获取蚂蚁金融的支付方式
    // getAntPay(type){
    //   let that=this
    //   let price=that.totalPrice(that.list.USD_TotalPrice,that.postPrice,'noString')
    //   if(that.again!=undefined){
    //     price=that.totalPrice(that.list.RealLowestPrice,that.postPrice,'noString')
    //   }
    //   let data={currency:that.areaSymbol,deviceType:1,userRegion:that.userInfo.MemberSource,amount:price}
    //    // that.disabled = true;
    //   that.$post(that.$interface.GetAntPayChannels,data).then(res=>{
    //     if(res.Result){
    //       that.antPayChannelsList=res.Data
    //       that.isOtherPay=!that.isOtherPay
    //       //type 普通订单进入
    //       if(type=='order'){
    //         that.antPayCheck(that.antPayChannelsList[0])
    //       }
    //     }else{
    //         that.$message({
    //           type: 'error',
    //           message: res.Msg
    //         });
    //     }
    //     //that.disabled = false;
    //   })
    // },
    //新增/修改地址 obj，val:new 新增，不然就是編輯
    /*
     * obj: 非新增要傳地址詳情
     * val:new 新增，不然就是編輯
     * 
     */
    addChange(obj, val) {
      this.dialogVisible = true
      if (val == 'new') {
        this.isNew = true;
        console.log("getAreas", this.getAreas, "newAdd", this.newAdd, "checkAdd", this.checkAdd, "passForm", this.passForm, 'this.isAgencyMO', this.isAgencyMO, 'this.list.SellMemberSource', this.list)
        this.newAdd = this.checkAdd;
        // if(this.userInfo.MemberSource=="MO"){
        //   this.passForm.Country=this.userInfo.MemberSource
        // }
        this.passForm.Country = this.userInfo.MemberSource
        if (this.isAgencyMO) {
          this.passForm.Country = this.list.SellMemberSource || this.list.MemberSource
        }
        this.checkAdd = this.passForm;
        this.IfDefault = false;
      } else {
        this.checkAdd = obj
        this.isNew = false;
        this.IfDefault = true;
      }
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      //this.disabled = false;
      this.loading = false
    },
    openMessgaeBox() {
      const html = `<div>
        <p>${this.$t('vault.Gradedcardssubmitted')}</p>
        <p>${this.$t('vault.CardsstoredinCardHobby')}</p>
        </div>`
      this.$alert(html, this.$t('base.hint'), {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false
      });
    }
  },
  //离开页面后
  destroyed() {

    //alert(2);
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.shopping_cart {
  margin: 40px 0;
  overflow: visible;
}

.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
}

.checkout_box h3>.addressNew {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
  font-weight: normal;
}

.shopping_box {
  border: none;
}

.shopping_list {
  width: 100%;
  gap: 10px;
  /* padding: 8px 12px; */
}

.shopping_list .list_price {
  margin: 0;
  flex: 1;
  width: auto
}

.shopping_list .like_box {
  display: flex;
  position: relative;
  /*width: 520px;*/
  width: 77%;
  text-align: left;
}

.shopping_list .like_box.BusinessType {
  width: 248px;
}

/* .shopping_list .like_box p {
  width: 265px;
} */

.shopping_list .like_box.BusinessType p {
  width: 148px;
}

/* .shopping_list .list_price {
  width: 105px;
  text-align: right;
  margin-left: 0;
}

.shopping_list .list_price.ServiceFee {
  width: 150px;
}

.shopping_list .list_price.postPrice {
  width: 110px;
} */

.avatar_box {
  display: flex;
  height: 40px;
  line-height: 40px;
  background-color: #f7f7f7;
  padding: 0 12px;
}

.avatar {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-top: 12px;
  margin-right: 5px;
}


/* .table_head {
  height: 48px;
  line-height: 48px;
  display: flex;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
} */

.head_box {
  width: 150px;
  padding: 0 12px;
  text-align: right;
}


.commod {
  width: 545px;
  padding-left: 110px;
  text-align: left;
}

/* .table_head .head_box {
  width: 110px;
}

.table_head .head_box.ordertotal {
  width: 140px;
}

.table_head .commod {

  width: 380px;
  padding-left: 110px;
}

.table_head .commod.BusinessType {
  width: 269px;
} */

.address_list,
.pay_list {
  display: flex;
  flex-wrap: wrap;
}

.address_list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(278px, 1fr));
  gap: 8px;
}

.address_list li {
  height: auto;
  border: 2px dashed #e0e0e0;
  margin-right: 0;
  margin-bottom: 0;
  padding: 0;
  min-height: 100px;
  position: relative;
  cursor: pointer;
}

.address_list li:nth-child(3n) {
  margin-right: 0;
}

.address_list li.on {
  border-color: #5f6dae;
}

.address_list li.on::after {
  content: "";
  border: 15px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -2px;
  bottom: -2px;
}

.address_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 4px;
  height: 10px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 5px;
  z-index: 2;
}

.address_list li>.choose_address {

  box-sizing: border-box;
  padding: 12px;
  width: auto;
  padding-bottom: 12px;
  padding-top: 10px;
  margin: 0;
}

.choose_address>div {
  margin-bottom: 10px;
}

.address_list li>div span {
  font-size: 16px;
  margin-right: 5px;
}

.address_list li.on .change {
  position: absolute;
  bottom: 16px;
  left: auto;
  right: 20px;
  z-index: 9;
}

.pay_list li {
  border: 1px solid #c8c8c8;
  position: relative;
  cursor: pointer;
  width: 185px;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 38px;
  text-align: center;
}

.pay_list li.disabled {
  background: #f7f7f7;
}

.pay_list li .pay_list_div {
  width: 100%;
  height: 100%;
}

.pay_list li .like_img {
  width: 100px;
  height: 24px;
  margin-top: 8px;
}

.pay_list li.on {
  border-color: #5f6dae;
  background: #f0f3ff;
}

.pay_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.pay_list li.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -1px;
  bottom: -1px;
}

.info_box {
  width: 240px;
  margin-left: 24px;
}

.address_box {
  width: 100%;
  display: flex;
}

.address_list_box {
  width: 160px;
}

.checkbox_save {
  margin-left: 24px;
}

.dialogBox {
  width: 875px;
}

.set_btn {
  text-align: right;
}

.Checkout {
  font-weight: normal;
}

.check_list_all,
.check_list .price {
  font-weight: bold;
  /*justify-content: flex-end;*/
}

.check_list .Couponprice {
  font-weight: bold;
  line-height: 36px;
}

.check_list .info_ipt {
  width: 100px;
}

.finish {
  margin: 10px auto 0;
  display: block;
  text-align: center;
}

.BusinessType {
  font-size: 16px;
  padding-bottom: 20px;
}

.price_r {
  text-align: right;
}

.Shipping_list .price {
  white-space: nowrap;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}


.shopping_list .like_box p .line_txt4 {
  display: -webkit-box;
  height: auto;
}

.isMOHK {
  cursor: pointer;
  display: inline-block;
}

.isMOHK:hover {
  text-decoration: underline;
}

.transferText {
  position: relative;
}

.isAgencyMO {
  position: absolute;
  left: 237px;
  top: -20px;
  padding: 8px 12px;
  display: none;
  width: 245px;
  border-radius: 4px;
  line-height: 1.4;
  font-size: 14px;
  z-index: 99;
  background-color: #fff;
  box-shadow: -2px 2px 16px 0px rgba(0, 0, 0, 0.10);
}

.transferText:hover .isAgencyMO {
  display: inline-block;
}

.isAgencyMO:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #fff;
  transform: rotate(45deg);
  position: absolute;
  bottom: 22px;
  left: -4px;
}

.others {
  text-align: center;
  font-size: 16px;
  color: #a0a0a0;
  margin-bottom: 20px;
}

.others>span {
  cursor: pointer;
  position: relative;
}

.others>span:after {
  content: "";
  width: 12px;
  height: 7px;
  background: url(../../../static/images/icon/icon_stroke.svg) no-repeat;
  background-size: contain;
  margin-left: 4px;
  display: inline-block;
}

.review_items {
  display: grid;
  grid-template-columns: 40% repeat(auto-fit, minmax(90px, 1fr));
  gap: 10px;
  text-align: center;
  min-height: 48px;
  align-items: center;
}

.table_head {
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
}

.review_list {
  align-items: baseline;
  margin-top: 20px;
  grid-template-columns: 52% repeat(auto-fit, minmax(90px, 1fr));
}

.vault_box {
  justify-self: start;
  display: flex;
  margin-bottom: 20px;
}

.vault_box .icon_process {
  background-repeat: no-repeat;
  width: 18px;
  background-size: contain;
  background-position-y: center;
  margin-left: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/quickcheckout.vue